import { Suspense } from "react";
import Loader from "../../layouts/Loader/Loader";

const LazyRoute = ({ children }) => (
    <Suspense fallback={<Loader />}>
        {children}
    </Suspense>
);

export default LazyRoute; 